<router-outlet></router-outlet>

@if (isImpersonated()) {
  <div class="impersonating">
      <div class="impersonating__bubble">
        <i class="fa-solid fa-mask"></i>
      </div>

      <div class="impersonating__modal">
        <p>{{ "impersonating.content" | transloco }}</p>
        <button
          class="button button--danger button--full-width"
          (click)="restoreAdmin()"
        >
          <i class="fa-solid fa-arrow-right-from-bracket"></i>
          {{ "impersonating.logout" | transloco }}
        </button>
      </div>
  </div>
}
